import { DomainLayout } from "@/components/layouts/DomainLayout";
import {DashboardView} from "../views/DashboardView.tsx";

export const DashboardPage = () => {
    return (
        <DomainLayout>
            <DashboardView />
        </DomainLayout>
    )
}